<!--   
<div *ngIf="loading[0]" class="overlay">
    <div class="spinner"></div><br>
    <h5 *ngIf="loading[1]">Submitting Company...</h5>
    <h5 *ngIf="loading[2]">Submitting Business Type...</h5>
    <h5 *ngIf="loading[3]">Submitting Contracts...</h5>
    <h5 *ngIf="loading[4]">Submitting Contract Details...</h5>
    <h5 *ngIf="loading[5]">Submitting Directors...</h5>
    <h5 *ngIf="loading[6]">Submitting Documents...</h5>
    <h5 *ngIf="loading[7]">Submitting HSE...</h5>
    <h5 *ngIf="loading[8]">Submitting Signatories...</h5>
    <h5 *ngIf="loading[9]">Submitting Subcontracts...</h5>
    <h5 *ngIf="loading[10]">Submitting Subsidaries...</h5>
    <h5 *ngIf="loading[11]">Submitting User...</h5>
  </div> -->


  <div *ngIf="loading" class="overlay">
    <div class="spinner"></div>
  </div>
  <div id="snackbar"></div>

<body class="grey lighten-3">
    <div *ngIf="firstVisit" class="firstVisit-toast">
        <h4 class="welcome-title">Welcome to the Vendor Registration Portal!</h4>
        
        <p class="intro-text">
            Watch this quick tutorial to get started with the registration process.
        </p>
        
        <div class="video-row">
            <div class="video-item" (click)="openLightbox('https://www.youtube.com/embed/0bRdzzMJY6c?si=id8cY9oCRwkQc1VO')">
                <div class="thumbnail">
                    <img src="https://img.youtube.com/vi/Kkj8D4mFz7s/0.jpg" alt="Intro to Form">
                    <div class="play-button">▶</div>
                </div>
                <p class="video-hint">
                    <i class="material-icons">play_circle_outline</i>
                    Click to watch tutorial
                </p>
            </div>
        </div>

        <div class="info-section">
            <p class="info-text">
                <strong>Important:</strong> This form includes external forms, documents, and multiple phases. 
                You can save your progress at each step and return anytime using the same email and password.
            </p>
        </div>
        
        <button class="close-btn" (click)="firstVisit = false" title="Close">×</button>
    </div>

    <div *ngIf="showRefreshBanner" class="refresh-banner">
        <i class="material-icons warning-icon">warning</i>
        <p>If data doesn't load as expected, please refresh the page.</p>
        <button class="close-btn" (click)="dismissRefreshBanner()">×</button>
    </div>

    <div *ngIf="isLightboxOpen" class="lightbox" (click)="closeLightbox()">
        <div class="lightbox-content" (click)="$event.stopPropagation()">
            <span class="lightbox-close" (click)="closeLightbox()">×</span>
            <iframe 
                [src]="selectedVideoUrl" 
                frameborder="0" 
                allowfullscreen 
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerpolicy="strict-origin-when-cross-origin">
            </iframe>
        </div>
    </div>

    <div class="bar">
        <div class="row-container">
            <div>
                <a href="/login">
                    <img src="/assets/unipet_text.png" width="180px" style="margin-left: 20px">
                </a>
            </div>

            <div class="site-title">
                VENDOR REGISTRATION PORTAL
            </div>
    
            <div class="right-side">
                <a class="help-link" (click)="openLightbox('https://www.youtube.com/embed/0bRdzzMJY6c?si=id8cY9oCRwkQc1VO')">
                    <span class="help-icon">?</span>
                    <span class="help-text">Need Help?</span>
                </a>
                <span class="divider">|</span>
                <a href="https://unipet.co.tt/procurement/" target="_blank"> Contact Us</a>
                <span class="divider">|</span>
                <a class="admin-nav-link fixed-bottom" (click)="attemptLogout()" routeLinkActive="active">LOGOUT</a>
            </div>
        </div>
    </div>
    

  <br>
  <br>
  <br>
  <br>
  <br>
  <br>

  <div *ngIf="errorLoading" class="error-message">
    <h6 class="server-msg"> Oh no! Couldn't Fetch Data.. <br> We'll be right back. </h6>
    <img src="/assets/car-mileage-compressed.gif" loading="lazy" height="100px" >
</div>

  <div *ngIf="!loading && currUser && currCompany">

  <div class="white panel-card">
    <h4> Registration Form Submission </h4>
    <h6 style="font-style: italic; margin-top: -10px; color: rgb(146, 146, 146); font-size: 16px;" > 
        Your progress won’t be saved until you save each page by clicking 'Next'. 
        <br> If you remain inactive or leave this page before submitting, everything you’ve entered will be lost.
    </h6>
    <p *ngIf="submissionError" class="error-message" role="alert" style="color: #c62828; margin: 12px 0;">{{ submissionError }}</p>

    <!-- <div class="progress-dots">
        <span *ngFor="let page of pages; let i = index" 
            [class.active]="i === currentPage"></span>
    </div> -->

    <div class="progress-dots">
        <span *ngFor="let page of pages; let i = index"
                [class.active]="i === currentPage"
                [class.completed]="i < currentPage">
            <ng-container *ngIf="i === currentPage">{{ i + 1 }}</ng-container>
        </span>
    </div>



    <button *ngIf="currentPage > 0" class="prev-btn" (click)="previousPage()">Previous</button>
    <button *ngIf="currentPage < pages.length - 1" class="next-btn" (click)="nextPage()">Next</button>
    <button *ngIf="currentPage == pages.length - 1" class="submit-btn" (click)="submit()">SUBMIT</button>

    <div *ngIf="savedMessage" [class.closing]="isClosingBanner" class="saved-banner">{{ savedMessage }}</div>

        <div class="form-container">
            <ng-container *ngIf="currentPage === 0">
                <app-a-customer-info [formData]="submittedData" [isOriginalSubmission]="true"></app-a-customer-info>
            </ng-container>
            <ng-container *ngIf="currentPage === 1">
                <app-c-documents-form [formData]="submittedData"></app-c-documents-form>   
            </ng-container>
            <ng-container *ngIf="currentPage === 2">
                <app-d-directors-authority-form [formData]="submittedData"></app-d-directors-authority-form>
            </ng-container>
            <ng-container *ngIf="currentPage === 3"> <!--todo: merge with step 2-->
                <app-e-top-customers [formData]="submittedData"></app-e-top-customers>
            </ng-container>
            <ng-container *ngIf="currentPage === 4">
                <app-f-health-safety [formData]="submittedData"></app-f-health-safety>
            </ng-container>
            <ng-container *ngIf="currentPage === 5">
                <app-g-terms-conditions [formData]="submittedData"></app-g-terms-conditions>
            </ng-container>
        </div>

        <div class="botton-naviagtion">
            <button *ngIf="currentPage > 0" class="prev-btn" (click)="previousPage()">Previous</button>
            <button *ngIf="currentPage < pages.length - 1" class="next-btn" (click)="nextPage()">Next</button>
            <button *ngIf="currentPage == pages.length - 1" class="submit-btn" (click)="submit()">SUBMIT</button>
        </div>
        
    </div>

  </div>
  <br>
</body>